export default {"src":"/_next/static/media/ruler-icon.2d718007.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};